module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Presupuesto mensual: Otros ingresos"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Presupuesto mensual: Otros ingresos',
      "videoEmbed": "ADMINISTRACIONDINERO25 PresupuestoMensualOtrosIngresos.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('p', [_vm._v("\n        En este cuadro debe escribir los ingresos mensuales que recibe por otros conceptos diferentes al salario. "), _c('br'), _vm._v("\n        Importante: no incluya puntos ni comas.\n      ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('ui-calculadora', {
    attrs: {
      "mostrarTotal": true,
      "formulario": _vm.ingresoSalario,
      "nombresCols": _vm.nombres,
      "resultadoDiferencia": _vm.resultadoDiferencia,
      "resultadoTotal": _vm.resultadoTotal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5760bf5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-25.vue
// module id = 996
// module chunks = 1